import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, FormControl, Validators } from '@angular/forms';

import { AlertService } from '../../services/alert.service';
import { BannerService } from '../../services/banner.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'banner-card',
    templateUrl: './banner-card.component.html',
    styleUrls: ['./banner-card.component.scss']
})
export class BannerCardComponent implements OnInit, OnDestroy {

    @Input()
    banner: any;

    @Output('refreshBanners')
    refreshEventEmitter = new EventEmitter<void>();

    bannerFormGroup!: FormGroup;

    deleteBannerVisible!: boolean;

    newLocaleBannerVisible!: boolean;

    newLocaleBannerFormGroup!: FormGroup;

    newLocaleBannerSelectedFile!: File;

    constructor(
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private bannerService: BannerService,
        private formBuilder: FormBuilder
    ) {
    }

    ngOnInit() {
        this.bannerFormGroup = this.formBuilder.group({
            bannerNameInput: [this.banner.name],
            bannerLinkInput: [this.banner.link],
            bannerActiveCheckbox: [this.banner.active],
            bannerZeTimeCheckbox: [this.banner.filters.includes('ZeTime')],
            bannerZeFit4Checkbox: [this.banner.filters.includes('ZeFit4')],
            bannerZeRound2Checkbox: [this.banner.filters.includes('ZeRound2')],
            bannerZeSport2Checkbox: [this.banner.filters.includes('ZeSport2')],
            bannerLocaleFormArray: this.formBuilder.array(this.banner.locales.map((locale: any) => {
                return this.formBuilder.group({
                    bannerLocaleLocaleInput: [locale.locale],
                    bannerLocaleLinkInput: [locale.link],
                    bannerLocaleUrlInput: [locale.url]
                });
            }))
        });
        this.newLocaleBannerFormGroup = this.formBuilder.group({
            newLocaleBannerFileInput: [null, Validators.required],
            newLocaleBannerLocaleInput: [null],
            newLocaleBannerLinkInput: [null]
        });
    }

    ngOnDestroy() {
    }

    getBannerLocaleFormArray(): any {
        return this.bannerFormGroup.get('bannerLocaleFormArray') as FormArray;
    }

    updateBanner() {

        let bannerFormGroup: FormGroup = this.bannerFormGroup;
        let name: string = bannerFormGroup.value.bannerNameInput;
        let link: string = bannerFormGroup.value.bannerLinkInput;
        let active: boolean = bannerFormGroup.value.bannerActiveCheckbox === true;
        let filters: string[] = [];
        let locales: any[] = [];

        if (bannerFormGroup.value.bannerZeTimeCheckbox === true) {
            filters.push('ZeTime');
        }
        if (bannerFormGroup.value.bannerZeFit4Checkbox === true) {
            filters.push('ZeFit4');
        }
        if (bannerFormGroup.value.bannerZeRound2Checkbox === true) {
            filters.push('ZeRound2');
        }
        if (bannerFormGroup.value.bannerZeSport2Checkbox === true) {
            filters.push('ZeSport2');
        }

        locales = bannerFormGroup.value.bannerLocaleFormArray.map((value: any) => ({
            locale: value.bannerLocaleLocaleInput,
            link: value.bannerLocaleLinkInput
        }));

        let banner: any = {
            name: name,
            link: link,
            active: active,
            filters: filters,
            locales: locales
        }

        this.progressIndicatorService.progress = true;
        this.bannerService.updateBanner(this.banner.id, banner).subscribe({
            next: (value: any) => {
                console.log('BannerCardComponent.updateBanner.bannerService.updateBanner.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.emitRefreshEvent();
            },
            error: (error: any) => {
                console.log('BannerCardComponent.updateBanner.bannerService.updateBanner.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    displayDeleteBanner() {
        this.deleteBannerVisible = true;
        setTimeout(() => this.deleteBannerVisible = false, 3000);
    }

    deleteBanner() {
        this.progressIndicatorService.progress = true;
        this.bannerService.deleteBanner(this.banner.id).subscribe({
            next: (value: any) => {
                console.log('BannerCardComponent.deleteBanner.bannerService.deleteBanner.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.emitRefreshEvent();
            },
            error: (error: any) => {
                console.log('BannerCardComponent.deleteBanner.bannerService.deleteBanner.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    newLocaleBannerFileInputChange(event: any) {
        let file: File = event.target.files[0];
        this.newLocaleBannerSelectedFile = file;
    }

    uploadNewBannerLocale() {

        let formGroup: FormGroup = this.newLocaleBannerFormGroup;
        let file: File = this.newLocaleBannerSelectedFile;
        let locale: string = formGroup.value.newLocaleBannerLocaleInput;
        let link: string = formGroup.value.newLocaleBannerLinkInput;

        this.progressIndicatorService.progress = true;
        this.bannerService.uploadNewBannerLocale(this.banner.id, file, locale, link).subscribe({
            next: (value: any) => {
                console.log('BannerCardComponent.uploadNewBannerLocale.bannerService.uploadNewBannerLocale.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.emitRefreshEvent();
            },
            error: (error: any) => {
                console.log('BannerCardComponent.uploadNewBannerLocale.bannerService.uploadNewBannerLocale.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    emitRefreshEvent() {
        this.refreshEventEmitter.emit();
    }
}
